import {
  fromPersistedTranscript,
  type PersistedTranscriptInput,
} from '@/lib/transcripts/persistence';
import type { TranscriptionMessage } from '@/store/slices/transcriptionSlice';

/** Row shape published by Realtime for public.transcript_segments. */
export interface TranscriptSegmentRow {
  call_id: string;
  sync_id: string;
  ordinal: number | string;
  content?: PersistedTranscriptInput | null;
}

/** Convert one normalized segment row through the canonical persistence mapper. */
export function transcriptSegmentRowToMessage(
  row: TranscriptSegmentRow | null | undefined,
): TranscriptionMessage | null {
  const content = row?.content;
  if (
    !row ||
    !content ||
    typeof content.message !== 'string' ||
    typeof content.timestamp_ms !== 'number' ||
    !Number.isFinite(content.timestamp_ms)
  ) {
    return null;
  }

  const ordinal = typeof row.ordinal === 'string' ? Number(row.ordinal) : row.ordinal;
  const index = Number.isSafeInteger(ordinal) && ordinal > 0 ? ordinal - 1 : 0;

  return fromPersistedTranscript(
    {
      ...content,
      sync_id: content.sync_id || row.sync_id,
    },
    index,
  );
}
